// src/features/prescriptions/prescriptionSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Define the base URL for the API
// const BASE_URL = "http://18.233.85.48:8080/api/";

export const fetchPrescriptions = createAsyncThunk(
  "prescriptions/fetchPrescriptions",
  async ({ userId, page = 1 }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get( `${process.env.REACT_APP_API_URL}/prescriptions/${userId}`, {
        headers: {
          Authorization: token,
        },
        params: { page, limit: 5 }, // Assuming pagination is supported
      });
      return response.data; // Return the full response data object
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error fetching prescriptions"
      );
    }
  }
);


// Async thunk for uploading prescriptions
export const uploadPrescription = createAsyncThunk(
  "prescriptions/uploadPrescription",
  async ({ file, userId }, { rejectWithValue }) => {
    const formData = new FormData();
    formData.append("files", file);
    formData.append("user_id", userId);
    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/prescriptions`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const prescriptionSlice = createSlice({
  name: "prescriptions",
  initialState: {
    prescriptions: [], // Store the prescriptions here
    totalPages: 0,
    currentPage: 1,
    uploadComplete: false,
    uploadStatus: "",
    loading: false,
    error: null,
  },
  reducers: {
    resetUpload: (state) => {
      state.uploadComplete = false;
      state.uploadStatus = "";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch prescriptions cases
    builder
      .addCase(fetchPrescriptions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPrescriptions.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.prescriptions = action.payload; // Directly assign the prescriptions data
          // If pagination data is available
          state.totalPages = action.payload.totalPages || 1;
          state.currentPage = action.payload.currentPage || 1;
        }
      })
      .addCase(fetchPrescriptions.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || "Failed to fetch prescriptions.";
      })
      // Upload prescription cases
      .addCase(uploadPrescription.pending, (state) => {
        state.loading = true;
        state.uploadStatus = "Uploading...";
        state.error = null;
      })
      .addCase(uploadPrescription.fulfilled, (state, action) => {
        state.loading = false;
        state.uploadComplete = true;
        state.uploadStatus = action.payload.message;
      })
      .addCase(uploadPrescription.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.uploadStatus = "Upload failed: " + action.payload.message;
      });
  },
});

export const { resetUpload } = prescriptionSlice.actions;
export default prescriptionSlice.reducer;
